export default "__VITE_ASSET__CHUe_WxQ__"